import React, { useState, useEffect, useRef } from 'react'
import _ from 'lodash'
import { Modal, Checkbox, Select, Spin, Empty, message } from 'antd'
import { Model, ModelBlock } from 'xadmin-model'
import { C } from 'xadmin-ui'
import { use, api, app } from 'xadmin'
import NodeTreeSelectMultiple from '../components/NodeTreeSelectMultiple'
import NoData from '../components/NoData'
import './NodeModalSelect.css'

const reverseConvert = (arr, ext) => arr.map(item => {
  return ext ? { id: item.key, uid: item.id, name: item.label } : { id: item.key, name: item.label }
})

const convert = (arr, ext) => arr.map(item => {
  return ext ? { key: item.id, uid: item.id, label: item.name } : { key: item.id, label: item.name }
})

const NodeList = props => {
  const { onChange, seleted, ext } = props

  const { loading, items } = use('model.list', props)
  const { activePage } = use('model.pagination', props)

  const [ allSelected, setAllSelected ] = useState({
    other: [], current: []
  })

  const [ state, setState ] = useState({})

  const onChangeClear = selected => {
    onChange(selected)
    const keys = allSelected && !_.isEmpty(allSelected) ? Object.keys(allSelected) : null
    const v = keys && keys.map(k => {
      const pageValues = allSelected[k]
      const other = _.intersectionBy(selected, pageValues, 'key')
      return { [k]: other }
    }).reduce((prev, cur) => ({ ...prev, ...cur }), {})
    setAllSelected(v)
  }

  const options = items.map(item => ({ key: item.id }))
  // 传入值转换为select value
  const seletedValue = seleted && !_.isEmpty(seleted) ? seleted : []
  // 传入值转换为check box value
  const checkboxValue = seletedValue && _.isArray(seletedValue) && seletedValue.map(item => JSON.stringify({ key: item.key, label: item.label }))
  const ln = checkboxValue.length

  useEffect(() => {
    if (seletedValue && seletedValue.length > 0) {
      const current = _.intersectionBy(options, seletedValue, 'key')
      const other = _.differenceBy(seletedValue, current, 'key')
      setAllSelected({ other, current })
      setState({
        [`indeterminate-${activePage}`]: !!current.length && current.length < options.length,
        [`checkAll-${activePage}`]: current.length === current.length
      })
    }
  }, [ activePage, ln, JSON.stringify(options) ])

  const checkboxOnChange = selected => {
    const currentActivePageValue = selected.map(item => JSON.parse(item))
    const newAllSelected = { ...allSelected, current: currentActivePageValue }
    setAllSelected(newAllSelected)
    const checked = [ ...newAllSelected.other, ...newAllSelected.current ]
    const newAllSelectedCurrent = newAllSelected.current
    setState({
      [`indeterminate-${activePage}`]: !!newAllSelectedCurrent.length && newAllSelectedCurrent.length < options.length,
      [`checkAll-${activePage}`]: newAllSelectedCurrent.length === options.length
    })
    onChange(checked)
  }

  const onCheckAllChange = e => {
    const checked = e.target.checked
    const all = items.map(item => ext ? JSON.stringify({ key: item.id, uid: item.id, label: item.name }) : JSON.stringify({ key: item.id, label: item.name }))
    if (checked) {
      checkboxOnChange(all)
    } else {
      checkboxOnChange([])
    }
  }

  return (
    <>
      <Select
        style={{ minWidth: 160, width: '100%', margin: '0px 0 18px' }}
        mode="multiple" open={false} labelInValue placeholder="已选择资产"
        onChange={onChangeClear} allowClear={true} value={seletedValue} >
      </Select>
      <ModelBlock name="model.list.submenu" />
      <div key="model-list-subnav" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '.5rem' }}>
        <C is="Model.Pagination" />
        {/* <C is="Model.ListSubMenu" /> */}
      </div>
      <div style={{ borderBottom: '1px solid #E9E9E9', marginBottom: 5, paddingBottom: 5 }}>
        <Checkbox
          key={`indeterminate-${activePage}`}
          indeterminate={state[`indeterminate-${activePage}`]}
          onChange={onCheckAllChange}
        // checked={state[`checkAll-${activePage}`]}
        >全部
        </Checkbox>
      </div>
      <Checkbox.Group
        className="node_select_checkbox"
        value={checkboxValue}
        onChange={checkboxOnChange}>
        {items && items.map(item => <Checkbox key={JSON.stringify({ key: item.id, label: item.name })} value={ext ? JSON.stringify({ key: item.id, uid: item.uid, label: item.name }) : JSON.stringify({ key: item.id, label: item.name })}>{item.name}</Checkbox>)}
        {items && _.isEmpty(items) && <Empty image={require('./../icon/homeIcon/noData.png')}
          imageStyle={{ height: 100, }}
          description={<span style={{ marginTop: '.5rem', display: 'inline-block' }}>暂无资产</span>}></Empty>}
        {loading && <Spin style={{ display: 'flex', justifyContent: 'center' }} size="large" />}
      </ Checkbox.Group>
    </>
  )
}

const NodeModelWrap = props => {
  let initialValues = { filter: { limit: 100 } }
  let submenu = [ 'model', 'name', { key: 'parent', component: NodeTreeSelectMultiple, filter: true } ]
  if(props?.modelId) {
    initialValues = {
      ...initialValues,
      wheres: { resetFilter: { modelId: props?.modelId } }
    }
    submenu = [ 'name', { key: 'parent', component: NodeTreeSelectMultiple, filter: true } ]
  }
  return (
    <Model name="Node" modelKey={'node-modal-select-'} props={{
      persistent: false,
      listFields: [ 'name' ],
      orders: { name: 'ASC' },
      filters: { submenu },
      initialValues
    }}>{props.children}
    </Model>
  )
}


const NodeModalSelect = props => {
  const { input: { onChange, value }, ext = false, modelId='' } = props
  const [ visible, setVisible ] = useState(false)
  const [ loading, setLoading ] = useState(false)
  let selectValue = value && !_.isEmpty(value) ? convert(value) : []
  const [ selected, setSelected ] = useState(selectValue)
  const [ seleVal, setSeleVal ] = useState([])
  // 打开资产面板，初始化默认值
  const onDropdownVisibleChange = v => {
    setVisible(true)
    setSelected(selectValue)
  }

  const handleCancel = () => { setVisible(false) }
  const onChangeClear = v => {
    onChange(reverseConvert(v, ext))
  }
  const handleOk = () => {
    onChange(reverseConvert(selected, ext))
    setVisible(false)
    getModelTypes()
  }

  const getModelTypes = () => {
    let Where = { 'id': { '$in': (selected || []).map(item => item && item.key) } }
    if (selected.length != 0) {
      setLoading(true)
      setSeleVal([ { key: '模型分类计算中...', label: '模型分类计算中...' } ])
      api('Node')
        .query({ fields: [ 'model' ] }, { Where })
        .then(({ items }) => {
          if (items) {
            const map = new Map()
            items.forEach(item => {
              const model = item && item['model']
              if (map.has(model['name'])) {
                const arr = map.get(model['name'])
                arr.push({ id: item.id, name: item.name, modelId: model.id })
              } else {
                map.set(model['name'], [ { id: item.id, name: item.name, modelId: model.id } ])
              }
              setSeleVal(Array.from(map).map(item => ({
                key: item[1][0]['modelId'], label: `${item[0]}(${item[1].length})`
              })))

              setLoading(false)
            })
          } else {
            setSeleVal([])
          }
        })
        .catch(err => {
          message.error('获取资产分类失败',err?.detail)
          setLoading(false)
          setSeleVal([])
        })
    } else {
      setSeleVal([])
      setLoading(false)
    }
  }

  React.useEffect(() => {
    getModelTypes()
  }, [])

  return (
    <>
      <Select
        open={false}
        labelInValue
        mode="multiple"
        value={seleVal}
        loading={loading}
        removeIcon={<></>}
        placeholder="请选择资产"
        onChange={onChangeClear}
        notFoundContent={<NoData />}
        style={{ minWidth: 160, width: '100%' }}
        onDropdownVisibleChange={onDropdownVisibleChange}
      // getPopupContainer={triggerNode => triggerNode.parentNode || document.body}
      >
      </Select>
      <Modal
        title="资产"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="确定"
        destroyOnClose={true}
        cancelText="取消"
        width="80%" >
        <NodeModelWrap modelId={modelId}>
          <NodeList ext={ext} onChange={setSelected} seleted={selected} />
        </NodeModelWrap>
      </Modal>
    </>
  )
}

const NodeModalSelectExt = props => <NodeModalSelect ext={true}  {...props} />

export { NodeModalSelectExt }

export default NodeModalSelect
